export default __webpack_public_path__ + "static/media/map2.e8349da8.webp";